<div mat-dialog-content>
    @if (isReadonly()) {
        <p class="readonly-note"><mat-icon inline>lock</mat-icon> This model is read-only, so the details can't be changed here.</p>
    }
    <app-node-properties [nodes]="[data.node]" [linqset]="data.linqset" [organisation]="data.organisation" [organisationLinqset]="data.organisationLinqset" [modelInsights]="data.linqset.insights" [readOnlyGraph]="isReadonly()" [graph]="data.graph" (executeFunctionEvent)="handleFunction($event)"></app-node-properties>
</div>
<div mat-dialog-actions align="end">
    <button mat-flat-button color="accent" [mat-dialog-close]="data.node">Done</button>
</div>
